import { useNavigate } from 'react-router-dom';
import { FilterIcon } from 'lucide-react';
import { FormFieldSelect } from './FormFieldSelect';
import { hasFeature } from '@/services/featureService';
import { Feature } from '@/utils/constant';

interface ServiceSwitcherProps {
  currentService: 'process' | 'delivery' | 'home-inspection';
}

export const ServiceSwitcher = ({ currentService }: ServiceSwitcherProps) => {
  const navigate = useNavigate();

  const allServiceOptions = [
    { label: 'Process Service', value: 'process' },
    { label: 'Delivery', value: 'delivery' },
    { label: 'Home Inspection', value: 'home-inspection' },
  ];

  const serviceOptions = allServiceOptions.filter((opt) => {
    if (opt.value === 'home-inspection') return hasFeature(Feature.HOME_INSPECTION);
    return true;
  });

  return (
    <FormFieldSelect
      name="serviceSwitcher"
      hasControl={false}
      icon={<FilterIcon className="h-4 w-4 text-[#969696]" />}
      options={serviceOptions}
      className="flex flex-row w-fit h-[36px] p-2 gap-6"
      defaultValue={currentService}
      onChange={(value) => {
        if (value === 'process') {
          navigate('/process');
        } else if (value === 'delivery') {
          navigate('/delivery');
        } else if (value === 'home-inspection') {
          navigate('/home-inspection');
        }
      }}
    />
  );
};
